// 处分认定
export default [
  {
    path: '/punishment/firmly-believe',
    component: resolve => require(['@/pages/punishment/firmly-believe.vue'], resolve),
    name: 'firmly-believe',
    meta: {
      title: '处分认定'
    }
  },
  {
    path: '/punishment/relieve',
    component: resolve => require(['@/pages/punishment/relieve.vue'], resolve),
    name: 'relieve',
    meta: {
      title: '处分解除'
    }
  },
  {
    path: '/punishment/manage',
    component: resolve => require(['@/pages/punishment/punishmentManage.vue'], resolve),
    name: 'punishmentManage',
    meta: {
      title: '处分管理'
    }
  },
  {
    path: '/punishment/statistics',
    component: resolve => require(['@/pages/punishment/punishmentStatistics.vue'], resolve),
    name: 'punishmentStatistics',
    meta: {
      title: '处分统计'
    }
  },
  {
    path: '/punishment/type-manage',
    component: resolve => require(['@/pages/punishment/type-manage.vue'], resolve),
    name: 'type-manage',
    meta: {
      title: '类型管理'
    }
  },
  {
    path: '/punishmentConfig',
    component: resolve => require(['@/pages/punishment/punishmentConfig.vue'], resolve),
    name: 'punishmentConfig',
    meta: {
      title: '处分解除配置'
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/modules/punishment.js